<template>
    <v-app class="p-sm-3 order-modal__wrapper" v-if="isLoaded">
        <div class="d-flex align-center justify-space-between w-full px-3 mb-3">
            <small></small>
            <v-btn text fab small class="mr-n3" @click="$emit('close')">
                <v-icon size="15">fa-times</v-icon>
            </v-btn>
        </div>
        <div class="order-modal" v-if="!isLoading">
            <div class="order-modal__header">
                {{ '#' + order.id + '-Order' }}
            </div>
            <div class="order-modal__body">
                <div class="order-modal__row">
                    <div class="d-flex py-2 row">
                        <div class="me-auto col-12 col-sm-auto" v-if="isNewOrder">
                            <v-btn
                                depressed
                                color="light"
                                class="custom--v-btn col-auto"
                                @click="reject(orderId)"
                            >
                                <v-icon size="15" class="mr-3">fa-times-circle</v-icon>
                                Reject
                            </v-btn>
                        </div>
                        <div class="me-auto col-12 col-sm-auto" v-if="isAcceptedOrder">
                            <v-btn
                                depressed
                                color="light"
                                class="custom--v-btn"
                                @click="reject_after_accepting(orderId)"
                            >
                                <v-icon size="15" class="mr-3">fa-times-circle</v-icon>
                                Cancel Job
                            </v-btn>
                        </div>
                        <div class="ms-sm-3 col-12 col-sm-auto"
                             v-if="isAcceptedOrder || isNewOrder"
                        >
                            <v-btn
                                depressed
                                color="secondary"
                                class="custom--v-btn"
                                @click="openRescheduleModal"
                            >
                                <v-icon size="15" class="mr-3">fa-clock</v-icon>
                                Reschedule
                            </v-btn>
                        </div>
                        <div class="ms-sm-3 col-12 col-sm-auto" v-if="isAcceptedOrder">
                            <v-btn
                                :disabled="!order.canComplete"
                                elevation="0"
                                color="light"
                                @click="complete(order.id)"
                            >
                                Complete
                            </v-btn>
                        </div>
                    </div>
                </div>
                <div class="order-modal__row">
                    <v-row class="order-modal__info">
                        <v-col class="col-auto" sm="12" md="6">
                            <h3 class="order-modal__title">Reservation</h3>
                            <ul>
                                <li>Date of move: <strong>{{ order.arrival_date }}</strong></li>
                                <li>Show-up time: <strong>{{ order.arrival_time }}</strong></li>
                                <li>Service method: <strong>{{ order.service }}</strong></li>
                                <li>Type of move: <strong>{{ order.type_moving }}</strong></li>
                                <li>Number of bedrooms: <strong>{{ order.bedrooms_count }}</strong></li>
                                <li>Number of floors: <strong>{{ order.stories_count }}</strong></li>
                            </ul>
                        </v-col>
                        <v-col class="col-auto" sm="12" md="6">
                            <h3 class="order-modal__title">Contact Info</h3>
                            <ul>
                                <li>Full name: <strong>{{ order.name }}</strong></li>
                                <li>Email: <a :href="`mailto:${order.email}`"><strong>{{ order.email }}</strong></a>
                                </li>
                                <li>
                                    Phone number: <br>
                                    <strong>
                                        {{ order.phone }}<br>
                                        {{ order.secondary_phone }}
                                    </strong>
                                </li>
                            </ul>
                        </v-col>
                        <v-col class="col-auto" sm="12" md="6" v-if="order.pickups.length > 0">
                            <h3 class="order-modal__title">Pickups</h3>
                            <ul v-for="{address, city_or_town, state, zip_code, type_property} of order.pickups"
                                :key="zip_code">
                                <li>Name of street & apt or suit #: <strong>{{ address + ' ' + city_or_town }}</strong>
                                </li>
                                <li>City name & State & Zip-code: <strong>{{ state + ' ' + zip_code }}</strong></li>
                                <li>Property Type: <strong>{{ property_types[type_property] }}</strong></li>
                            </ul>
                        </v-col>
                        <v-col class="col-auto" sm="12" md="6" v-if="order.destinations.length > 0">
                            <h3 class="order-modal__title">Destinations</h3>
                            <ul v-for="{address, city_or_town, state, zip_code, type_property} of order.destinations"
                                :key="zip_code">
                                <li>Name of street & apt or suit #: <strong>{{ address + ' ' + city_or_town }}</strong>
                                </li>
                                <li>City name & State & Zip-code: <strong>{{ state + ' ' + zip_code }}</strong></li>
                                <li>Property Type: <strong>{{ property_types[type_property] }}</strong></li>
                            </ul>
                        </v-col>
                        <v-col class="col-auto" sm="12" md="6">
                            <h3 class="order-modal__title">Order details</h3>
                            <ul>
                                <li>Number of helpers: <strong>{{ order.helpers_count }}</strong></li>
                                <li>Minimum hours: <strong>{{ order.hours_count }}</strong></li>
                                <li>Type of help: <strong>{{ order.type_help }}</strong></li>
                                <li>Transportation type: <strong>{{ order.type_transportation.join(', ') }}</strong>
                                </li>
                                <li v-if="order.truck_size">
                                    Size of truck: <strong>{{ order.truck_size }}</strong>
                                </li>
                                <li>Payment type: <strong>{{ order.type_payment }}</strong></li>
                                <li>Payment method: <strong>{{ orderDetailsPaymentMethod }}</strong></li>
                                <li v-if="order.unique_items">
                                    Extra heavy items:
                                    <strong>{{ order.unique_items }}</strong>
                                </li>
                            </ul>
                        </v-col>
                    </v-row>
                </div>
                <div class="order-modal__row">
                    <div
                        v-if="order.cash_prices || order.electronic_prices"
                    >
                      <div class="tw-grid tw-grid-cols-3 tw-gap-[45px]">
                        <div class="tw-col-span-2">
                          <h3 class="tw-mb-[5px] tw-text-[16px] tw-text-secondary tw-font-[500]">
                            Customer selected {{ order.payment_method === CASH ? 'Cash' : 'Electronic' }}
                          </h3>
                          <table
                            class="tw-col-span-2 tw-w-full tw-border tw-border-solid tw-border-[#E0E4E9] tw-border-collapse"
                          >
                            <thead>
                            <tr class="tw-bg-primary">
                              <th class="tw-p-[12px_20px] tw-text-white tw-text-left">
                                Item
                              </th>
                              <th
                                v-if="order.payment_method === CASH"
                                class="tw-p-[12px_20px] tw-text-white tw-text-right"
                              >
                                Subtotal (Cash)
                              </th>
                              <th
                                class="tw-p-[12px_20px] tw-text-white tw-text-right"
                                v-if="order.payment_method === ELECTRONIC"
                              >
                                Subtotal (Electronic)
                              </th>
                            </tr>
                            </thead>
                            <tbody class="tw-text-secondary tw-font-[500] [&_tr:nth-child(odd)]:tw-bg-[#f5f5f9] [&_tr:nth-child(even)]:tw-bg-[#FFF] [&_td]:tw-p-[12px_20px] [&_td:not(:first-child)]:tw-text-right">
                            <tr>
                              <td>Base Hourly Rate</td>
                              <td v-if="order.payment_method === CASH">
                                {{ '$' + order.cash_prices.hour_rate + '/hr (Cash)' }}
                              </td>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ '$' + order.electronic_prices.hour_rate + '/hr (Electronic)' }}
                              </td>
                            </tr>
                            <tr>
                              <td>Service Fee</td>
                              <td v-if="order.payment_method === CASH">
                                {{ '$' + order.cash_prices.service_fee }}
                              </td>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ '$' + order.electronic_prices.service_fee }}
                              </td>
                            </tr>
                            <tr>
                              <td>Double Drive Time</td>
                              <td v-if="order.payment_method === CASH">
                                {{ this.order.invoice.is_double_drive ? ('Applies / $' + this.order.cash_prices.double_drive_price) : 'Does not apply' }}
                              </td>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ this.order.invoice.is_double_drive ? ('Applies / $' + this.order.electronic_prices.double_drive_price) : 'Does not apply' }}
                              </td>
                            </tr>
                            <tr>
                              <td>{{ `Total for ${this.order.hours_count}-hour minimum` }}</td>
                              <td v-if="order.payment_method === CASH">
                                ${{ order.cash_prices.total }}
                              </td>
                              <td v-if="order.payment_method === ELECTRONIC">
                                ${{ order.electronic_prices.total }}
                              </td>
                            </tr>
                            <tr>
                              <td>TopHelpers Fee</td>
                              <td v-if="order.payment_method === CASH" class="tw-text-[red]">
                                - ${{ order.cash_prices.processing_fee }}
                              </td>
                              <td v-if="order.payment_method === ELECTRONIC" class="tw-text-[red]">
                                - ${{ order.electronic_prices.processing_fee }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total Payout</td>
                              <td v-if="order.payment_method === CASH">
                                {{ '$' + (order.cash_prices.total - order.cash_prices.processing_fee) + ' (Cash)' }}
                              </td>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ '$' + (order.electronic_prices.total - order.electronic_prices.processing_fee) + ' (Electronic)' }}
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                        <div>
                          <h3 class="tw-mb-[5px] tw-text-[16px] tw-text-secondary tw-font-[500]">
                            In case of {{ order.payment_method === CASH ? 'Electronic' : 'Cash' }} payment

                            <v-tooltip
                              bottom
                              color="gray"
                              max-width="360"
                              content-class="charge-text__tooltip"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" size="16" class="!tw-m-[-2px_0_0_2px]">
                                  fa-info-circle
                                </v-icon>
                              </template>
                              <div>
                                <p v-if="order.payment_method === CASH">This section shows the correct amounts to charge if the customer decides to switch from Cash payment to an electronic method (Credit Card, PayPal, Zelle, Venmo, CashApp, etc.).</p>
                                <p v-else>This section shows the correct amounts to charge if the customer decides to switch from Electronic(card) payment rate to cash rate.</p>
                                <p class="!tw-mb-0">The TopHelpers fee stays the same as what the customer already paid during checkout. No extra TopHelpers fee is added when switching between Cash and Electronic payments.</p>
                              </div>
                            </v-tooltip>

                          </h3>
                          <table
                            v-if="order.cash_prices || order.electronic_prices"
                            class="tw-w-full tw-border tw-border-solid tw-border-[#E0E4E9] tw-border-collapse"
                          >
                            <thead>
                            <tr class="tw-bg-secondary">
                              <th
                                v-if="order.payment_method === ELECTRONIC"
                                class="tw-p-[12px_20px] tw-text-white tw-text-right"
                              >
                                Subtotal (Cash)
                              </th>
                              <th
                                class="tw-p-[12px_20px] tw-text-white tw-text-right"
                                v-if="order.payment_method === CASH"
                              >
                                Subtotal (Electronic)
                              </th>
                            </tr>
                            </thead>
                            <tbody class="tw-text-secondary tw-font-[500] [&_tr:nth-child(odd)]:tw-bg-[#f5f5f9] [&_tr:nth-child(even)]:tw-bg-[#FFF] [&_td]:tw-p-[12px_20px] tw-text-right">
                            <tr>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ '$' + order.cash_prices.hour_rate + '/hr (Cash)' }}
                              </td>
                              <td v-if="order.payment_method === CASH">
                                {{ '$' + order.electronic_prices.hour_rate + '/hr (Electronic)' }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ '$' + order.cash_prices.service_fee }}
                              </td>
                              <td v-if="order.payment_method === CASH">
                                {{ '$' + order.electronic_prices.service_fee }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ this.order.invoice.is_double_drive ? ('Applies / $' + this.order.cash_prices.double_drive_price) : 'Does not apply' }}
                              </td>
                              <td v-if="order.payment_method === CASH">
                                {{ this.order.invoice.is_double_drive ? ('Applies / $' + this.order.electronic_prices.double_drive_price) : 'Does not apply' }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="order.payment_method === ELECTRONIC">
                                ${{ order.cash_prices.total }}
                              </td>
                              <td v-if="order.payment_method === CASH">
                                ${{ order.electronic_prices.total }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="order.payment_method === ELECTRONIC" class="tw-text-[red] tw-opacity-0 tw-select-none">
                                - ${{ order.cash_prices.processing_fee }}
                              </td>
                              <td v-if="order.payment_method === CASH" class="tw-text-[red] tw-opacity-0 tw-select-none">
                                - ${{ order.electronic_prices.processing_fee }}
                              </td>
                            </tr>
                            <tr>
                              <td v-if="order.payment_method === ELECTRONIC">
                                {{ '$' + (order.cash_prices.total - order.electronic_prices.processing_fee) + ' (Cash)' }}
                              </td>
                              <td v-if="order.payment_method === CASH">
                                {{ '$' + (order.electronic_prices.total - order.cash_prices.processing_fee) + ' (Electronic)' }}
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div class="tw-mt-[15px] tw-text-secondary">
                        <p class="!tw-mb-[5px] tw-text-[18px]">
                          <strong>Note:</strong>
                        </p>

                        <p>
                          The customer selected the
                          <strong>{{ order.payment_method === CASH ? "Cash" : "Electronic" }}</strong>
                          payment rate during
                          checkout. If the customer chooses to complete the remaining balance using

                          <span v-if="order.payment_method === CASH">
                            an <strong>Electronic</strong> payment method <em>({{ getCompanyPaymentMethods }})</em>,
                          </span>
                          <span v-else>
                            the Cash payment methond,
                          </span>

                          the {{ order.payment_method === CASH ? "electronic" : "cash" }} total rate will apply.
                          <br>
                          In this case, the remaining {{ order.payment_method === CASH ? "Electronic" : "Cash" }}
                          Total Payout is calculated as:

                          <strong v-if="order.payment_method === CASH">
                            {{ `$${ order.electronic_prices.total } - $${ order.cash_prices.processing_fee } = $${ order.electronic_prices.total - order.cash_prices.processing_fee }` }}
                          </strong>
                          <strong v-if="order.payment_method === ELECTRONIC">
                            {{ `$${ order.cash_prices.total } - $${ order.electronic_prices.processing_fee } = $${ order.cash_prices.total - order.electronic_prices.processing_fee }` }}
                          </strong>
                        </p>

                        <p class="!tw-mb-[5px] tw-text-[18px]">
                          <strong>TopHelpers Fee Explanation:</strong>
                        </p>

                        <p>
                          The TopHelpers fee shown in the table is already deducted from the total order price (see
                          the “{{ `Total for ${this.order.hours_count}-hour minimum` }}” row).
                          Total Payout represents the actual amount you should collect from the customer.
                        </p>
                      </div>
                    </div>

                    <table
                      v-else
                      class="tw-w-full tw-border tw-border-solid tw-border-[#E0E4E9] tw-border-collapse"
                    >
                      <thead>
                        <tr class="tw-bg-secondary">
                          <th class="tw-p-[12px_20px] tw-text-white tw-text-left">Item</th>
                          <th class="tw-p-[12px_20px] tw-text-white tw-text-right">Subtotal ({{ this.orderDetailsPaymentMethodV2 }})</th>
                        </tr>
                      </thead>
                      <tbody
                        class="tw-text-secondary tw-font-[500] [&_tr:nth-child(odd)]:tw-bg-[#f5f5f9] [&_tr:nth-child(even)]:tw-bg-[#FFF] [&_td]:tw-p-[12px_20px] [&_td:not(:first-child)]:tw-text-right">
                        <tr>
                          <td>Base Hourly Rate</td>
                          <td>
                            {{ '$' + this.order.invoice.hourly + '/hr (' + this.orderDetailsPaymentMethodV2 + ')' }}
                          </td>
                        </tr>
                        <tr>
                          <td>Service Fee</td>
                          <td>{{ '$' + this.order.invoice.service_fee }}</td>
                        </tr>
                        <tr>
                          <td>Double Drive Time</td>
                          <td>{{ this.order.invoice.is_double_drive ? ('Applies / $' + this.order.double_drive_price) : 'Does not apply' }}</td>
                        </tr>
                        <tr>
                          <td>{{ `Total for ${this.order.hours_count}-hour minimum` }}</td>
                          <td>${{ totalHoursPrice }}</td>
                        </tr>
                        <tr>
                          <td>TopHelpers Fee</td>
                          <td class="tw-text-[red]">{{ '- $' + (this.order.redeem_enabled || this.order.processing_fee === 0 ? this.order.invoice.hourly * 0.75 : this.order.processing_fee) }}</td>
                        </tr>
                        <tr>
                          <td>Total</td>
                          <td>{{ '$' + totalWithoutFee + ' (' + this.orderDetailsPaymentMethodV2 + ')' }}</td>
                        </tr>
                      </tbody>
                    </table>
                </div>
                <div v-if="isCustomer ? order.customerCanReview : order.helperCanReview"
                     class="order-modal__action d-flex align-center justify-center my-4">
                    <v-btn class="custom--v-btn" color="primary" @click="openReviewModal">
                        Set Review
                    </v-btn>
                </div>
            </div>
        </div>
    </v-app>

    <app-loading-indicator v-else/>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import loading from "../../mixins/loading";
import AppLoadingIndicator from "../AppLoadingIndicator";
import {ORDER_STATUSES, PROPERTY_TYPES} from "@/plugins/data";
import AppReschedule from "@/components/Modals/AppReschedule";
import {successConfirmAction, warningConfirmAction} from "@/plugins/swal";
import AppReview from "@/components/Modals/AppReview.vue";
import { CASH, ELECTRONIC } from '@/plugins/consts';

export default {
    props: {
        orderId: {
            type: Number,
            required: true
        }
    },

    mixins: [loading],

    components: {
        AppLoadingIndicator,
    },

    data() {
        return {
            /** @type {Order|null} */
            order: null,

            headers: [
                {text: 'Item', sortable: false, value: 'item',},
                {text: 'Subtotal', sortable: false, value: 'subtotal'},
            ],

            property_types: PROPERTY_TYPES,
            CASH, ELECTRONIC,
        };
    },

    methods: {
        ...mapActions('orders', ['show']),
        ...mapActions('company', { loadCompany: 'load' }),

        load() {
            this.startLoading(async () => {
                this.order = await this.show(this.orderId);
            });
        },

        openRescheduleModal() {
            this.$modal.show(AppReschedule, {
                order: this.order,
                afterClose: this.$attrs.afterClose,
            }, {
                width: 1000,
                height: 700,
            }, {
                closed: this.$attrs.afterClose
            });
        },

        reject(order_id) {
            warningConfirmAction('Do you really want to reject this order?', 'Reject it', async () => {
                await this.$store.dispatch('dashboard/reject', order_id);
                this.load();
            });
        },

        reject_after_accepting(order_id) {
            warningConfirmAction('Do you really want to reject accepted order?', 'Reject it', async () => {
                await this.$store.dispatch('dashboard/reject_after_accepting', order_id);
                this.load();
            });
        },

        complete(order_id) {
            successConfirmAction("Do you really want to complete this order?", 'Complete it', async () => {
                await this.$store.dispatch('dashboard/complete', order_id)
            });
        },

        openReviewModal() {
            this.$modal.show(AppReview, {
                order: this.order
            }, {
                width: 764,
                height: 700,
            }, {
                closed: this.load
            });
        },
    },

    computed: {
        ...mapGetters('auth', ['isCustomer']),

        getCompanyPaymentMethods() {
            const paymentMethods = this.$store.state.company.company?.payment_methods || [];
            return paymentMethods.map(method => method.name).join(', ');
        },

        isCompletedOrder() {
            return this.order.status_id === ORDER_STATUSES.STATUS_COMPLETED
        },

        isNewOrder() {
            return this.order.status_id === ORDER_STATUSES.STATUS_NEW;
        },

        isAcceptedOrder() {
            return this.order.status_id === ORDER_STATUSES.STATUS_ACCEPTED
        },

        orderDetailsPaymentMethod() {
          if (this.order.payment_method === CASH) {
            return 'Cash Rate';
          } else if (this.order.payment_method === ELECTRONIC) {
            return 'Electronic (card rate)';
          }
          return 'Cash Rate';
        },

        orderDetailsPaymentMethodV2() {
          if (this.order.payment_method === CASH) {
            return 'Cash';
          } else if (this.order.payment_method === ELECTRONIC) {
            return 'Electronic';
          }
          return 'Cash';
        },

      totalHoursPrice() {
        const hoursCount = parseFloat(this.order.hours_count) || 0;
        const hourly = parseFloat(this.order.invoice.hourly) || 0;
        const serviceFee = parseFloat(this.order.invoice.service_fee) || 0;
        const doubleDrivePrice = parseFloat(this.order.double_drive_price) || 0;

        const totalHoursPrice = hoursCount * hourly;
        const doubleDrive = this.order.invoice.is_double_drive ? doubleDrivePrice : 0;

        return totalHoursPrice + serviceFee + doubleDrive;
      },

      totalWithoutFee() {
        const total = parseFloat(this.order.invoice.total) || 0;
        const processingFee = parseFloat(this.order.processing_fee) || 0;

        return total - processingFee;
      }
    },

    async created() {
        this.load();
    },

    mounted() {
        this.loadCompany();
    },
}
</script>

<style lang="scss" scoped>
.order-modal {
    margin: 0 12px 12px 12px;

    &__header {
        padding: 8px 15px;
        text-align: center;
        font-weight: bold;
        font-size: 20px;
        color: #FFF;
        background-color: #8F3985;
    }

    &__body {
        border: 1px solid #E0E4E9;
        border-top: 0;
    }

    &__row {
        padding: 15px;

        &:not(:last-child) {
            border-bottom: 1px solid #E0E4E9;
        }

        //    mobile

        @media (max-width: 599px) {
            .custom--v-btn::v-deep, button {
                width: 100%;
                margin-right: 0 !important;
                margin-left: 0 !important;
            }
        }
    }

    &__title {
        color: #0D3659;
        font-size: 18px;
        font-weight: 800;
        margin-bottom: 10px;
    }

    &__info {

        ul {
            margin: 0;
            padding: 0;
            list-style: none;

            li {
                color: #0D3659;
                font-size: 14px;

                strong {
                    font-weight: 700;
                }
            }
        }
    }

    // Customize vuetify components
    ::v-deep {

        // Textarea
        .v-textarea {
            margin-bottom: 15px;

            fieldset {
                border: 0 !important;
            }

            textarea {
                padding: 0 10px;

                &::-webkit-input-placeholder {
                    font-size: 14px;
                }

                &:-ms-input-placeholder {
                    font-size: 14px;
                }

                &::placeholder {
                    font-size: 14px;
                }
            }
        }

        .custom--v-table {

            th, td {
                padding: 8px 20px;

                &:first-child {
                    white-space: nowrap;
                }

                &:last-child {
                    text-align: right !important;
                }
            }
        }
    }
}

//mobile order-modal
@media only screen and (max-width: 830px) {
    .order-modal__wrapper {
        max-width: 95%;
        margin: 0 auto;
    }
}
</style>
